module.exports = __webpack_public_path__ + "assets/img/252a-sd.svg";